export default "__VITE_ASSET__BjJGF9VK__"